import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import moment from 'moment';
import ReactDOM from 'react-dom';

import Modal from 'components/GeneralComponents/Modal';
import Confirm from './Confirm';
import SearchDialogue from './SearchDialogue';
import constants from '../../constants';
import './Header.scss';
import styled from './styled';

class Header extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      debug: true,
      searchTerm: '',
      locInfo: '',
      openActionMenu: false,
      openOperationMenu: false,
      openSortMenu: false,
      openFilterMenu: false,
      showConfirm: false,
      showConfirmOperation: false,
      selectedAction: null,
      showConfirmStep2: false,
      addOperation: false,
      dropdownPos: null,
      actionMenuPos: null,
      selectedSort: null,
      ascending: true,
      openSearchWin: false,
      selectedFilter: null,
      selectedStatus: null,
      selectedWeekday: null,
      showFilterStatus: false,
      showFilterWeekday: false,
    };

    this.messages = defineMessages({
      placeholder: {
        id: 'Header.placeholder',
        defaultMessage: 'Search',
      },
    });

    this.topRowRef = React.createRef();
    this.openRef = React.createRef();
    this.actionRef = React.createRef();
    this.addRef = React.createRef();
    this.removeRef = React.createRef();
    this.operationRef = React.createRef();
    this.sortRef = React.createRef();
    this.sortWinRef = React.createRef();
    this.filterWinRef = React.createRef();
    this.filterRef = React.createRef();
    this.statusRef = React.createRef();
    this.weekdayRef = React.createRef();

    this._isMounted = false;

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.searchTimeout = null;
  }

  componentDidMount() {
    const { locationData, locations, requestedOperation, locationSettings, notifySearchTermChanged, notifySortTypeChanged, searchTerm } = this.props;
    const { sortTypes, } = constants;

    this._isMounted = true;
    this.setState({ searchTerm: searchTerm || '' });
    notifySearchTermChanged(searchTerm || '');
    if (requestedOperation && requestedOperation.length > 0) {
      this.setState({ showConfirmOperation: true });
    }

    const date = (<FormattedMessage
      id="HeaderComponent.date"
      defaultMessage="Date"
    />);

    const itemDate = { name: sortTypes.DATE, body: date };

    this.setState({ selectedSort: itemDate });
    notifySortTypeChanged(itemDate);

    document.addEventListener("mousedown", this.handleClickOutside);

  }

  componentDidUpdate(prevProps, prevState) {
    const { requestedOperation, selectedShifts, searchTerm } = this.props;
    const {
      openActionMenu, openOperationMenu, 
      openSortMenu, openFilterMenu, addOperation
    } = this.state;

    if (prevProps.searchTerm !== searchTerm) {
      this.setState({ searchTerm: searchTerm || '' });
    }

    // Helper: get bounding box and apply offset
    const getRefPosition = (ref, offset = 0) => {
      if (ref?.current) {
        const domNode = ReactDOM.findDOMNode(ref.current);
        const rect = domNode?.getBoundingClientRect();
        if (rect) {
          return {
            top: `${rect.y + rect.height + offset}px`,
            left: `${rect.x}px`
          };
        }
      }
      return null;
    };

    // 1. Handle requestedOperation change
    if (prevProps.requestedOperation !== requestedOperation && requestedOperation?.length > 0) {
      this.setState({ showConfirmOperation: true });
    }

        // 2. Menu toggles and dropdown position logic
        const menus = [
          {
            changed: prevState.openActionMenu !== openActionMenu,
            isOpen: openActionMenu,
            ref: this.openRef,
            default: { width: '200px', height: '100px' },
          },
          {
            changed: prevState.openOperationMenu !== openOperationMenu,
            isOpen: openOperationMenu,
            ref: addOperation ? this.addRef : this.removeRef,
            default: { width: '100px', height: '100px' },
            offset: 15
          },
          {
            changed: prevState.openSortMenu !== openSortMenu,
            isOpen: openSortMenu,
            ref: this.sortRef,
            default: { width: '400px', height: '128px' }
          },
          {
            changed: prevState.openFilterMenu !== openFilterMenu,
            isOpen: openFilterMenu,
            ref: this.filterRef,
            default: { width: '200px', height: '128px' }
          }
        ];

    for (const menu of menus) {
      if (menu.changed && menu.isOpen) {
        const pos = getRefPosition(menu.ref, menu.offset || 0);
        if (pos) {
          this.setState({
            dropdownPos: {
              top: pos.top,
              left: pos.left,
              width: menu.default.width,
              height: menu.default.height
            }
          });
        }
      }
    }

    // 3. Reset filters if all selectedShifts were deselected
    if (prevProps.selectedShifts !== selectedShifts &&
        prevProps.selectedShifts.length > 0 &&
        selectedShifts.length === 0) {
      this.setState({
        selectedFilter: null,
        selectedStatus: null,
        selectedWeekday: null,
        showFilterStatus: false,
        showFilterWeekday: false,
      });
    }
  }


  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener("mousedown", this.handleClickOutside);
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  handleClickOutside = (event) => {
    const { openActionMenu, openOperationMenu, openSortMenu, openFilterMenu, } = this.state;
    const { notifyDropDownOpened, } = this.props;

    if (this.openRef && this.openRef.current && !this.openRef.current.contains(event.target)) {
      if (this.actionRef && this.actionRef.current && !this.actionRef.current.contains(event.target)) {
        if (openActionMenu) {
          this.setState({ openActionMenu: false });
          notifyDropDownOpened(false);
        }
      }
    }

    if (this.addRef && this.addRef.current && !this.addRef.current.contains(event.target)) {
      if (this.operationRef && this.operationRef.current && !this.operationRef.current.contains(event.target)) {
        if (openOperationMenu) {
          this.setState({ openOperationMenu: false });
          notifyDropDownOpened(false);
        }
      }
    }

    if (this.removeRef && this.removeRef.current && !this.removeRef.current.contains(event.target)) {
      if (this.operationRef && this.operationRef.current && !this.operationRef.current.contains(event.target)) {
        if (openOperationMenu) {
          this.setState({ openOperationMenu: false });
          notifyDropDownOpened(false);
        }
      }
    }

    if (this.sortRef && this.sortRef.current && !this.sortRef.current.contains(event.target)) {
      if (this.sortWinRef && this.sortWinRef.current && !this.sortWinRef.current.contains(event.target)) {
        if (openSortMenu) {
          this.setState({ openSortMenu: false });
          notifyDropDownOpened(false);
        }
      }
    }

    if (this.filterRef && this.filterRef.current && !this.filterRef.current.contains(event.target)) {
      if (this.filterWinRef && this.filterWinRef.current && !this.filterWinRef.current.contains(event.target)) {
        if (openFilterMenu) {
          this.setState({ openFilterMenu: false });
          notifyDropDownOpened(false);
        }
      }
    }
  }

  handleKeyPress = (event) => {
    const { notifySearchTermChanged, } = this.props;
    const { searchTerm, } = this.state;

    if (event.keyCode === 13) {
      notifySearchTermChanged(searchTerm);
    }
  }

  handleSearchChanged = (event) => {
    const { notifySearchTermChanged, } = this.props;
    event.preventDefault();
    this.setState({ searchTerm: event.target.value });
    if (event.target.value === '') {
      notifySearchTermChanged('');
    }
  }

  handleSearchInputChange = (event) => {
    const { notifySearchTermChanged, } = this.props;
    const searchTerm = event.target.value;
    
    this.setState({ searchTerm });
    
    // Clear any existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    
    // Debounce the search to avoid too many API calls
    this.searchTimeout = setTimeout(() => {
      notifySearchTermChanged(searchTerm);
    }, 400);
  }

  handleCloseFilter = (filter) => {
    const { filterTypes, } = constants;
    const { notifyFiltersSelected, } = this.props;
    const { selectedStatus, selectedWeekday } = this.state;

    this.setState({ openSearchWin: false });
    switch (filter) {
      case filterTypes.STATUS:
        this.setState({ showFilterStatus: false, selectedStatus: null });
        notifyFiltersSelected(null, null, null, null, null, null, null, selectedWeekday);
        break;
      case filterTypes.WEEKDAY:
        this.setState({ showFilterWeekday: false, selectedWeekday: null });
        notifyFiltersSelected(null, selectedStatus, null, null, null, null, null, null);
        break;
    }

  }

  handleAddFilterClick = (event) => {
    const { openFilterMenu, } = this.state;

    event.preventDefault();

    this.setState({ openFilterMenu: !openFilterMenu });
  }

  handleHideFilterClick = (event) => {
    event.preventDefault();
    alert('clicked')
  }

  handleClearAllClick = (event) => {
    event.preventDefault();
    alert('clicked')
  }

  handleSortOrderChanged = (event) => {
    const { ascending, } = this.state;
    const { notifySortOrderChanged, } = this.props;
    this.setState({ ascending: !ascending });
    notifySortOrderChanged(!ascending);
  }

  handleRefreshClick = (event) => {
    const { notifyRefreshRequested, } = this.props;
    event.preventDefault();
    notifyRefreshRequested();
    this.setState({
      selectedFilter: null,
      selectedStatus: null,
      selectedWeekday: null,
      showFilterStatus: false,
      showFilterWeekday: false,
    });
  }

  handleActionChange = (action) => {
    const { notifyDropDownOpened, } = this.props;

    this.setState({ openActionMenu: false, showConfirm: true, selectedAction: action });
    notifyDropDownOpened(false);
  }

  handleFilterChange = (filter) => {
    const { notifyDropDownOpened, } = this.props;
    const { filterTypes } = constants;

    this.setState({ openFilterMenu: false, openSearchWin: true, selectedFilter: filter });
    notifyDropDownOpened(false);
    switch (filter.name) {
      case filterTypes.STATUS:
        this.setState({ showFilterStatus: true });
        break;
      case filterTypes.WEEKDAY:
        this.setState({ showFilterWeekday: true });
        break;
      }
  }

  notifyConfirm = (request) => {
    const { selectedAction, } = this.state;
    const { notifyActionRequested, } = this.props;
    const { userActionTypes } = constants;

    this.setState({ showConfirm: false });
    if (selectedAction.name === userActionTypes.REMOVE) {
      if (request) {
        this.setState({ showConfirmStep2: true });
      } else {
        notifyActionRequested(request, selectedAction.name);
      }
    } else {
      notifyActionRequested(request, selectedAction.name);
    }
  }

  notifySearchDone = (filter) => {
    const { selectedFilter, selectedStatus, selectedWeekday } = this.state;
    const { filterTypes, } = constants;
    const { notifyFiltersSelected, } = this.props;

    this.setState({ openSearchWin: false });

    switch (selectedFilter.name) {
      case filterTypes.STATUS:
        this.setState({ selectedStatus: filter });
        notifyFiltersSelected(null, filter, null, null, null, null, null, selectedWeekday);
        break;
      case filterTypes.WEEKDAY:
        this.setState({ selectedWeekday: filter });
        notifyFiltersSelected(null, selectedStatus, null, null, null, null, null, filter);
        break;
    }
  }

  renderFilterMenu = () => {
    const { dropdownPos, showFilterStatus, showFilterWeekday } = this.state;
    const { locationSettings, } = this.props;
    const { filterTypes, } = constants;

    const statusText = (<FormattedMessage
      id="Header.status"
      defaultMessage="Status"
    />);
    const weekdayText = (<FormattedMessage
      id="Header.weekday"
      defaultMessage="Weekday"
    />);

    const itemStatus = { name: filterTypes.STATUS, body: statusText };
    const itemWeekday = { name: filterTypes.WEEKDAY, body: weekdayText };

    let items = [];
    if (locationSettings && locationSettings.cfg__departments !== 1) {
      if (!showFilterStatus) {
        items.push(itemStatus);
      }
      if (!showFilterWeekday) {
        items.push(itemWeekday);
      }
    } else {
      if (!showFilterStatus) {
        items.push(itemStatus);
      }
      if (!showFilterWeekday) {
        items.push(itemWeekday);
      }
    }

    const filterItems = items.map((item, index) => (
      <div
        key={index}
        className="employee-page-header__dropdown-item-wrap"
        value={item}
        onClick={(event) => { this.handleFilterChange(item) }}
      >
        <label className="employee-page-header__action-dropdown-text">
          {item.body}
        </label>
      </div>
    ));
    if (dropdownPos) {
      return (
        <styled.WinContainer ref={this.filterWinRef} top={dropdownPos.top} left={dropdownPos.left} width={dropdownPos.width} height={dropdownPos.height}>
          {filterItems}
        </styled.WinContainer>
      );
    }

  }


  handleApproveClick = (selectedPendingRTOs, selectedPendingShifts) => {
    const { userActionTypes } = constants;
    const approveText = (<FormattedMessage
      id="RequestsV3.approve"
      defaultMessage="Approve Requests?"
    />);

    const action = { name: userActionTypes.APPROVE, body: approveText };
    this.setState({ showConfirm: true, selectedAction: action });
  }

  handleDenyClick = (selectedPendingRTOs, selectedPendingShifts) => {
    const { userActionTypes } = constants;
    const denyText = (<FormattedMessage
      id="RequestsV3.deny"
      defaultMessage="Deny Requests?"
    />);
   
    const action = { name: userActionTypes.DENY, body: denyText };
    this.setState({ showConfirm: true, selectedAction: action });
  }

  handleOperationChange = (operation) => {
    const { notifyOperationRequested, notifyDropDownOpened, } = this.props;
    this.setState({ openOperationMenu: false });
    notifyOperationRequested(operation);
    notifyDropDownOpened(false);
  }

  handleSortDropdownClick = (event) => {
    const { openSortMenu, } = this.state;
    const { notifyDropDownOpened, } = this.props;

    this.setState({ openSortMenu: !openSortMenu });
    notifyDropDownOpened(!openSortMenu);
  }

  handleSortChange = (sort) => {
    const { notifySortTypeChanged, notifyDropDownOpened, } = this.props;

    this.setState({ openSortMenu: false, selectedSort: sort });
    notifySortTypeChanged(sort);
    notifyDropDownOpened(false);
  }


  renderOperationItems = () => {
    const { locations, locationSettings, } = this.props;
    const { addOperation, dropdownPos, } = this.state;
    const { operationTypes, } = constants;

    const departmentText = (<FormattedMessage
      id="Header.department"
      defaultMessage="Department"
    />);
    const groupText = (<FormattedMessage
      id="Header.group"
      defaultMessage="Group"
    />);
    const skillsText = (<FormattedMessage
      id="Header.skills"
      defaultMessage="Skills"
    />);

    const assignUsersToDept = { name: operationTypes.ASSIGN_USERS_TO_DEPT, body: departmentText };
    const assignUsersToGroup = { name: operationTypes.ASSIGN_USERS_TO_GROUP, body: groupText };
    const assignUsersToSkill = { name: operationTypes.ASSIGN_USERS_TO_SKILL, body: skillsText };
    const removeUsersFromDept = { name: operationTypes.REMOVE_USERS_FROM_DEPT, body: departmentText };
    const removeUsersFromGroup = { name: operationTypes.REMOVE_USERS_FROM_GROUP, body: groupText };
    const removeUsersFromSkills = { name: operationTypes.REMOVE_USERS_FROM_SKILL, body: skillsText };

    let addItems = [assignUsersToDept, assignUsersToGroup, assignUsersToSkill];
    let removeItems = [removeUsersFromDept, removeUsersFromGroup, removeUsersFromSkills];
    if (locationSettings && locationSettings.cfg__departments !== 1) {
      addItems = [assignUsersToGroup, assignUsersToSkill];
      removeItems = [removeUsersFromGroup, removeUsersFromSkills];
    }
    if (locationSettings && locationSettings.cfg__skill !== 1) {
      addItems = [assignUsersToDept, assignUsersToGroup];
      removeItems = [removeUsersFromDept, removeUsersFromGroup];
    }
    if (locationSettings && locationSettings.cfg__departments !== 1 && locationSettings.cfg__skill !== 1) {
      addItems = [assignUsersToGroup];
      removeItems = [removeUsersFromGroup];
    }

    const items = addOperation ? addItems : removeItems;

    const operationItems = items.map((item, index) => (
      <div
        key={index}
        className="category__dropdown-item-wrap"
        value={item}
        onClick={(event) => { this.handleOperationChange(item) }}
      >
        <label className="category__action-dropdown-text">
          {item.body}
        </label>
      </div>
    ));
    if (dropdownPos) {
      return (
        <styled.WinContainer ref={this.operationRef} top={dropdownPos.top} left={dropdownPos.left} width={dropdownPos.width} height={dropdownPos.height}>
          {operationItems}
        </styled.WinContainer>
      );
    }
  }

  renderSortMenu = () => {
    const { dropdownPos, } = this.state;
    const { sortTypes, } = constants;

    const date = (<FormattedMessage
      id="HeaderComponent.date"
      defaultMessage="Date"
    />);

    const itemDate = { name: sortTypes.DATE, body: date };
    const items = [itemDate];
    const sortItems = items.map((item, index) => (
      <div
        key={index}
        className="employee-page-header__dropdown-item-wrap"
        value={item}
        onClick={(event) => { this.handleSortChange(item) }}
      >
        <label className="employee-page-header__action-dropdown-text">
          {item.body}
        </label>
      </div>
    ));
    if (dropdownPos) {
      return (
        <styled.WinContainer ref={this.sortWinRef} top={dropdownPos.top} left={dropdownPos.left} width={dropdownPos.width} height={dropdownPos.height}>
          {sortItems}
        </styled.WinContainer>
      );
    }

  }


  render() {
    const { showConfirm, 
      selectedAction, openSortMenu, selectedSort, ascending,
      openFilterMenu, showFilterStatus, showFilterWeekday, 
      openSearchWin, dropdownPos, selectedFilter, selectedStatus, selectedWeekday  } = this.state;
    const {  filteredResults, 
      selectedShifts,  channels,  departments, skills, intl,  isRequests  } = this.props;
    const { filterTypes, } = constants;

    const submit = moment();
    const submittedTime = `${submit.format('MMM DD, YYYY')}`;
    const usersOnTable = filteredResults ? filteredResults.length : 0;
    const selectedPendingRTOs = [];
    const selectedApprovedRTOs = [];
    const selectedDeniedRTOs = [];
    const selectedPendingShifts = [];
    const selectedApprovedShifts = [];
    const selectedDeniedShifts = [];
    const selectedPendingListItems = [];
    const selectedApprovedListItems = [];
    const selectedDeniedListItems = [];

    if (selectedShifts && selectedShifts.length > 0) {
      selectedShifts.forEach((shift) => {
        if (shift !== undefined) {
          const isShift = shift.time_off_reason === undefined;
          if (!isShift) {
            //RTO
            switch (shift.status) {
              case 'requested':
                selectedPendingRTOs.push(shift);
                selectedPendingListItems.push(shift);
                break;
              case 'approved':
                selectedApprovedRTOs.push(shift);
                selectedApprovedListItems.push(shift);
                break;
              case 'denied':
                selectedDeniedRTOs.push(shift);
                selectedDeniedListItems.push(shift);
                break;
            }
          } else if (shift.coverer) {
            switch (shift.coverer.applicantStatus) {
              case '#p':
                selectedPendingShifts.push(shift);
                selectedPendingListItems.push(shift);
                break;
              case '#a':
                selectedApprovedShifts.push(shift);
                selectedApprovedListItems.push(shift);
                break;
              case '#d':
                selectedDeniedShifts.push(shift);
                selectedDeniedListItems.push(shift);
                break;
              default:
                if (!(shift.parent_card || (!shift.parent_card && shift.cover_mode === 'multi_applicants_picked_by_manager'))) {
                  if (shift.trade_status === 'pending') {
                    selectedPendingShifts.push(shift);
                    selectedPendingListItems.push(shift);
                  } else if (shift.trade_status === 'approved') {
                    selectedApprovedShifts.push(shift);
                    selectedApprovedListItems.push(shift);
                  } else if (shift.trade_status === 'denied') {
                    selectedDeniedShifts.push(shift);
                    selectedDeniedListItems.push(shift);
                  }
                }
                break;
            }
          }
        }
      });
    }

    const sortButtonClassName = openSortMenu ? "employee-page-header__sort-arrow-button-up" : "employee-page-header__sort-arrow-button-down";
    const sortOrderButtonClassName = ascending ? 'employee-page-header__sort-order-descending' : 'employee-page-header__sort-order-ascending';
    let showFilterButton = true;
   
    const sortBy = (<FormattedMessage
      id="Header.sortBy"
      defaultMessage="Sort by"
    />);
    const userRoleText = (<FormattedMessage
      id="Header.userRole"
      defaultMessage="User Role"
    />);

    const results = (<FormattedMessage
      id="Header.results"
      defaultMessage="{number} results"
      values={{ number: usersOnTable }} />);

    const addFilters = (<FormattedMessage
      id="Header.addFilters"
      defaultMessage="Add Filters"
    />);
    const approveUsers = (<FormattedMessage
      id="Header.approveUsers"
      defaultMessage="Approve {number}"
      values={{ number: selectedPendingListItems.length }} />);

    const denyUsers = (<FormattedMessage
      id="Header.denyUsers"
      defaultMessage="Deny {number}"
      values={{ number: selectedPendingListItems.length }} />);

    const statusIs = (<FormattedMessage
      id="Header.statusIs"
      defaultMessage="Status is"
    />);
    const weekdayIs = (<FormattedMessage
      id="Header.weekdayIs"
      defaultMessage="Weekday is"
    />);

    const sortBoxText = selectedSort ? selectedSort.body : userRoleText;

    //Has selected shifts are pending 
    if (selectedPendingListItems.length > 0) {
      return (
        <div className="employee-page-header__top-wrap">
          <div className="employee-page-header__wrap">
            <div className="employee-page-header__row-1" ref={this.topRowRef}>
              <label className="employee-page-header__dropdown-text">{isRequests ? 'Requests' : 'Records'}</label>
            </div>
            <div className="employee-page-header__row-2">
              <div className="employee-page-header__button-group-1-wrap">
                <button className="employee-page-header__approve-users" onClick={() => this.handleApproveClick(selectedPendingRTOs, selectedPendingShifts)}>{approveUsers}</button>
                <button className="employee-page-header__deny-users" onClick={() => this.handleDenyClick(selectedPendingRTOs, selectedPendingShifts)}>{denyUsers}</button>
              </div>
              <div className="employee-page-header__sort-drop-down" ref={this.sortRef} onClick={this.handleSortDropdownClick}>{sortBy}
                <label className="employee-page-header__sort-item-text">{sortBoxText}</label>
                <button className={sortButtonClassName} />
              </div>
              <button className={sortOrderButtonClassName} onClick={this.handleSortOrderChanged} />
              <button className="employee-page-header__refresh-button" onClick={this.handleRefreshClick} />
            </div>
          </div>
          {openSortMenu && <Modal>
            {this.renderSortMenu()}
          </Modal>}
          {showConfirm && <Modal>
            <Confirm
              selectedAction={selectedAction}
              notifyConfirm={this.notifyConfirm}
              selectedPendingRTOs={selectedPendingRTOs}
              selectedPendingShifts={selectedPendingShifts}
              selectedShifts={selectedShifts}
            />
          </Modal>}
          <styled.Overlay display={showConfirm ? 'block' : 'none'} />
        </div>
      );
    }


    return (
      <div className="employee-page-header__top-wrap">
        <div className="employee-page-header__wrap">
          <div className="employee-page-header__row-1" ref={this.topRowRef}>
            <div className="employee-page-header__location-dropdown-wrap">
              <label className="employee-page-header__dropdown-text">{isRequests ? 'Requests' : 'Records'}</label>
            </div>
            <label className="employee-page-header__results-text">{results}</label>
          </div>
          <div className="employee-page-header__row-2">
          
          <div className="employee-page-header__search-wrap">
              <input
                type="text"
                placeholder="Search" 
                value={this.state.searchTerm}
                onChange={this.handleSearchInputChange}
                className="employee-page-header__search-input"
              />
            </div>

            <div className="employee-page-header__filter-wrap">
              {showFilterStatus && <div className="employee-page-header__filter" ref={this.statusRef} onClick={(event) => { this.handleCloseFilter(filterTypes.STATUS) }}>
                <p className="employee-page-header__filter-text">{statusIs}</p>
                <p className="employee-page-header__item-name">
                  {selectedStatus && Array.isArray(selectedStatus) && selectedStatus.length > 0
                    ? selectedStatus.map((status) =>
                      typeof status.label === 'string'
                        ? status.label
                        : intl.formatMessage(status.label)
                    ).join(', ')
                    : ''}
                </p>
              </div>}
              {showFilterWeekday && <div className="employee-page-header__filter" ref={this.weekdayRef} onClick={(event) => { this.handleCloseFilter(filterTypes.WEEKDAY) }}>
                <p className="employee-page-header__filter-text">{weekdayIs}</p>
                <p className="employee-page-header__item-name">
                  {selectedWeekday && Array.isArray(selectedWeekday) && selectedWeekday.length > 0
                    ? selectedWeekday.map((weekday) =>
                      typeof weekday.label === 'string'
                        ? weekday.label
                        : intl.formatMessage(weekday.label)
                    ).join(', ')
                    : ''}
                </p>
              </div>}
            </div>
          
            {showFilterButton && <button className="employee-page-header__add-filters" ref={this.filterRef} onClick={this.handleAddFilterClick}>{addFilters}</button>}
            <div className="employee-page-header__sort-drop-down" ref={this.sortRef} onClick={this.handleSortDropdownClick}>{sortBy}
              <label className="employee-page-header__sort-item-text">{sortBoxText}</label>
              <button className={sortButtonClassName} />
            </div>
            <button className={sortOrderButtonClassName} onClick={this.handleSortOrderChanged} />
            <button className="employee-page-header__refresh-button" onClick={this.handleRefreshClick} />
          </div>
        </div>
        {openSortMenu && <Modal>
          {this.renderSortMenu()}
        </Modal>}
        {openFilterMenu && <Modal>
          {this.renderFilterMenu()}
        </Modal>}

         {openSearchWin && <Modal>
          <SearchDialogue
            departments={departments}
            channels={channels}
            skills={skills}
            notifySearchDone={this.notifySearchDone}
            position={dropdownPos}
            selectedFilter={selectedFilter}
          />
        </Modal>}
      </div>
    );
  }
}

Header.propTypes = {
  selectedItem: PropTypes.object.isRequired,
  selectedType: PropTypes.string.isRequired,
  notifySearchTermChanged: PropTypes.func,
  searchTerm: PropTypes.string,
};

Header.defaultProps = {
  notifySearchTermChanged: () => {},
  searchTerm: '',
};

export default injectIntl(Header);

